import { DEFAULT_CURRENCY_RATE } from '../constants/CommonConstants';
import { TASK_STATUS } from '../constants/TaskConstants';

const strToNumber = (value) => {
  return Number(value);
};
export default strToNumber;

// will sort a array of objects depending on the booling condition and return it either ascending or in descending format
export function sortItemsWithValueToBottom(array, sortValue, sortCondition) {
  return array.sort(function ({ [sortCondition]: a }, { [sortCondition]: b }) {
    if (a === true) return 1;
    if (b === false) return -1;
    return (b - a) * sortValue;
  });
}

// creates an array by combining nested string arrays
export const createEntityLevelMap = (levels, entityIds) => {
  const multipleLinkedEntities = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [index, levelEntry] of levels.entries()) {
    if (!multipleLinkedEntities[`${levelEntry}s`]) {
      multipleLinkedEntities[`${levelEntry}s`] = [];
    }
    multipleLinkedEntities[`${levelEntry}s`].push(entityIds[index]);
  }
  return multipleLinkedEntities;
};

// Check the description and return the correct output
export const getDescription = (
  currentDescription, // The current description value
  updatedDescription // The updated description value
) => {
  try {
    if (
      currentDescription &&
      updatedDescription &&
      currentDescription === updatedDescription
    ) {
      // If the current and updated descriptions are the same, return the current description
      return currentDescription;
    }

    if (updatedDescription?.length) {
      // If the updated description is not null or undefined and has a non-zero length,
      // return the updated description as a JSON string
      return JSON.stringify(updatedDescription);
    }

    // If the updated description is null, undefined, or an empty string,
    // return null indicating no description
    return null;
  } catch (error) {
    // If any error occurs during the JSON stringification, return null
    return null;
  }
};

export const clearSuccessPlanUrl = (location, history) => {
  const { pathname, search } = location;
  const successPlanIdRegex = /\/success-plans\/\d+/;
  const updatedPathname = pathname.replace(
    successPlanIdRegex,
    '/success-plans'
  );
  const searchParams = new URLSearchParams(search);
  searchParams.delete('successPlanId');
  searchParams.delete('milestone');
  const newSearch = searchParams.toString();
  history.replace({ pathname: updatedPathname, search: newSearch });
};

export const currencyConversion = (
  sourceValue,
  sourceCurrency,
  conversionCurrencyDefinitionId,
  exchangeRates,
  baseCurrency
) => {
  const conversionRate =
    baseCurrency.currencyDefinitionId === sourceCurrency
      ? DEFAULT_CURRENCY_RATE
      : exchangeRates.find(
          (exchangeRate) => exchangeRate.currencyDefinitionId === sourceCurrency
        )?.conversionRate ?? DEFAULT_CURRENCY_RATE;
  const conversionCurrencyExchangeRate = exchangeRates.find(
    (exchangeRate) =>
      exchangeRate.currencyDefinitionId === conversionCurrencyDefinitionId
  );
  const displayValue =
    (sourceValue *
      (!conversionCurrencyExchangeRate?.conversionRate
        ? DEFAULT_CURRENCY_RATE
        : conversionCurrencyExchangeRate?.conversionRate) ??
      DEFAULT_CURRENCY_RATE) / conversionRate;
  return displayValue;
};

export const findObjectByValue = (data, targetValue) =>
  Object.values(data).find((item) => item.value === targetValue);

export const sortSuccessPlanTask = (tasks) => {
  return [
    ...tasks
      .filter(({ status }) => status !== TASK_STATUS.ARCHIVED)
      .sort((a, b) => (a.milestoneTaskOrder < b.milestoneTaskOrder ? -1 : 1)),
    ...tasks
      .filter(({ status }) => status === TASK_STATUS.ARCHIVED)
      .sort((a, b) => (a.milestoneTaskOrder < b.milestoneTaskOrder ? -1 : 1)),
  ];
};

export function isSuccessPlanCountViewable(history, selectedViewId) {
  const { pathname } = history.location;
  // if you add more tabs add that url here
  const parts = [
    'playbooks/instances',
    'playbooks/tasks',
    'playbooks/templates',
  ];
  return !parts.some((part) => pathname.includes(part)) || selectedViewId;
}

export const generateMilestoneTaskOrder = (taskId) => {
  return `0|lcm${taskId}1`;
};
